var hasRequestIdleCallback = function hasRequestIdleCallback(window) {
  return 'requestIdleCallback' in window;
};

export var safelyRequestIdleCallback = function safelyRequestIdleCallback(cb) {
  if (typeof window === 'undefined') return;

  if (hasRequestIdleCallback(window)) {
    window.requestIdleCallback(function () {
      cb && cb();
    });
  } else {
    window.setTimeout(function () {
      cb && cb();
    }, 0);
  }
};